var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 291.5 363.3",
    style: {
      enableBackground: "new 0 0 291.5 363.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#565656;}\n\t.st1{fill:#BF0000;}\n\t.st2{font-family:'Poppins-SemiBold';}\n\t.st3{font-size:299.9823px;}\n\t.st4{fill:none;stroke:#F8F8F8;stroke-width:7.9995;stroke-miterlimit:3.9998;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 10.081)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 184.635)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M208.2,54.4C240.5,1.2,223.5-68,170.4-100.2S48.1-115.6,15.8-62.4S0.5,59.9,53.6,92.2 c35.9,21.8,80.8,21.8,116.7,0l76.4,76.3l37.9-37.9L208.2,54.4z M112.3,65.7c-38.3,0-69.4-31.1-69.4-69.5 c0-38.3,31.1-69.4,69.5-69.4c38.3,0,69.4,31.1,69.4,69.5C181.7,34.7,150.6,65.7,112.3,65.7L112.3,65.7z"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.9511 0.309 -0.309 0.9511 96.0556 183.5829)",
    className: "st1 st2 st3"
  }, "?"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.9511 0.309 -0.309 0.9511 96.0556 183.5829)",
    className: "st4 st2 st3"
  }, "?"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/not-found.72d5d71d02472a73462ffaf9f9501c02.svg";
export { ForwardRef as ReactComponent };